export type WordToken = {
  id: number;
  text: string;
  start: number;
  length: number;
};

const isBoundaryPunctuation = (character: string) =>
  '.,!?;:"“”‘’()[]{}…'.includes(character);

export const tokenizeInput = (value: string): WordToken[] =>
  Array.from(value.trim().matchAll(/\S+/g)).flatMap((match, index) => {
    const token = match[0];
    let wordStart = 0;
    let wordEnd = token.length;

    while (wordStart < wordEnd && isBoundaryPunctuation(token[wordStart])) {
      wordStart++;
    }

    while (wordEnd > wordStart && isBoundaryPunctuation(token[wordEnd - 1])) {
      wordEnd--;
    }

    if (wordStart === wordEnd) {
      return [];
    }

    return [{
      id: index,
      text: token.slice(wordStart, wordEnd),
      start: (match.index ?? 0) + wordStart,
      length: wordEnd - wordStart,
    }];
  });
